var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.iconsSizeInXsBreakpoint,
          expression: "iconsSizeInXsBreakpoint",
        },
      ],
      class: ["custom-field-type-selector", _vm.breakpointClass],
    },
    [
      _c("div", { staticClass: "row-title" }, [
        _c("span", { staticClass: "row-text" }, [
          _vm._v(_vm._s(_vm.texts.title)),
        ]),
      ]),
      _c(
        "ul",
        { staticClass: "fields-list" },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "li",
            {
              class: ["item", { "xs-breakpoint": _vm.isXsBreakpoint }],
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.emitClickedItem(item)
                },
              },
            },
            [
              _c("span", { class: [_vm.getIcon(item.id), "item-icon"] }),
              !_vm.isXsBreakpoint
                ? _c("span", { staticClass: "item-name" }, [
                    _vm._v(_vm._s(item.description)),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }